window.lowPowerModeDetected = false;

document.addEventListener("DOMContentLoaded", () => {
  // Adds a loaded attribute to lazy loaded images when they are loaded
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');
  lazyImages.forEach((img) => {
    img.setAttribute("loaded", img.complete ? "true" : "false");
    img.onload = () => {
      img.setAttribute("loaded", "true");
    };
  });

  // Throttle and observer for autoplay efficiency
  let throttleTick = false;
  const handleVideoIntersection = (video) => {
    if (video.isIntersecting) {
      video.target.play();
    } else {
      video.target.pause();
    }
    throttleTick = false;
  };
  const observerCallback = (entries) => {
    if (throttleTick) return;
    throttleTick = true;
    window.requestAnimationFrame(() => {
      entries.forEach(handleVideoIntersection);
    });
  };
  const observer = new IntersectionObserver(observerCallback);

  const videos = document.querySelectorAll("video[data-src]");
  videos.forEach((video) => {
    video.src = video.dataset.src;
    video.poster = video.dataset.poster;
    video.setAttribute("loaded", "true");

    if (video.hasAttribute("data-autoplay")) {
      video.play();
      // If the video is still paused it's probably in lower mode and not going to play at all
      if (video.paused) video.removeAttribute("src");
      if (video.paused) {
        window.lowPowerModeDetected = true;
      }

      // Only play the video when it's in view
      observer.observe(video);
    } else {
      video.dispatchEvent(new Event("lazyHandled"));
    }
  });
}); // Shared JavaScript

// Global variable to control logo animation
window.canAnimateLogo = true;

// SignupForm Modal Object
const SignupForm = {
  modal: null,
  backdrop: null,
  modalWrapper: null,
  modalContent: null,
  closeButton: null,
  emailInput: null,

  init() {
    this.modal = document.getElementById("signup-form-modal");
    if (!this.modal) {
      console.warn("SignupForm: Modal element not found");
      return;
    }

    this.backdrop = this.modal.querySelector(".signup-form__backdrop");
    this.modalWrapper = this.modal.querySelector(".signup-form");
    this.modalContent = this.modal.querySelector(".signup-form__content");
    this.closeButton = this.modal.querySelector(".signup-form__close");
    this.emailInput = this.modal.querySelector("#Email");

    this.bindEvents();
    this.checkUrlForSuccess();
  },

  bindEvents() {
    // Close button click
    if (this.closeButton) {
      this.closeButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.hide();
      });
    }

    // Backdrop click
    if (this.backdrop) {
      this.backdrop.addEventListener("click", (e) => {
        // Only close if clicking directly on the backdrop, not its children
        if (e.target === this.backdrop) {
          this.hide();
        }
      });
    }

    // Escape key to close
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isVisible()) {
        this.hide();
      }
    });
  },

  checkUrlForSuccess() {
    // Check if URL contains the success parameters
    const urlParams = new URLSearchParams(window.location.search);
    const hasCustomerPosted = urlParams.get("customer_posted") === "true";
    const hasContactFormHash = window.location.hash === "#contact_form";

    if (hasCustomerPosted && hasContactFormHash) {
      // Disable logo animation
      window.canAnimateLogo = false;
      this.show(2);
      // Clean up URL without refreshing page
      this.cleanUrl();
    }
  },

  showStep1() {
    if (!this.modal) return;
    this.modal.classList.remove("step-2");
  },

  showStep2() {
    if (!this.modal) return;
    this.modal.classList.add("step-2");
  },

  cleanUrl() {
    // Remove the success parameters from URL without page refresh
    const url = new URL(window.location);
    url.searchParams.delete("customer_posted");
    url.hash = "";
    window.history.replaceState({}, document.title, url.pathname + url.search);
  },

  show(step = 1) {
    if (!this.modal) {
      console.warn("SignupForm: Cannot show modal - modal element not found");
      return;
    }

    // Set the appropriate step
    if (step === 1) {
      this.showStep1();
    } else if (step === 2) {
      this.showStep2();
    }

    // Show the modal
    this.modal.classList.add("show");

    // Only animate for step 1, show immediately for step 2
    if (step === 1) {
      // Add animate.css classes for fade in animation
      if (this.backdrop) {
        this.backdrop.classList.add("animate__animated", "animate__fadeIn");
      }
      if (this.modalContent) {
        this.modalContent.classList.add("animate__animated", "animate__zoomIn");
      }

      // Focus on email input after animation
      setTimeout(() => {
        if (this.emailInput) {
          this.emailInput.focus();
        }
      }, 300);
    }
    // For step 2, no animation - just show immediately

    // Prevent body scroll
    document.body.style.overflow = "hidden";
  },

  hide() {
    if (!this.modal || !this.isVisible()) {
      console.warn(
        "SignupForm: Cannot hide modal - modal not found or not visible"
      );
      return;
    }

    // Add fade out animation
    if (this.backdrop) {
      this.backdrop.classList.remove("animate__fadeIn");
      this.backdrop.classList.add("animate__fadeOut");
    }

    if (this.modalContent) {
      this.modalContent.classList.remove("animate__zoomIn");
      this.modalContent.classList.add("animate__zoomOut");
    }

    // Hide modal after animation completes
    setTimeout(() => {
      this.modal.classList.remove("show");

      // Clean up animation classes
      if (this.backdrop) {
        this.backdrop.classList.remove("animate__animated", "animate__fadeOut");
      }
      if (this.modalContent) {
        this.modalContent.classList.remove(
          "animate__animated",
          "animate__zoomOut"
        );
      }

      // Reset to step 1 when modal is hidden
      this.showStep1();

      // Restore body scroll
      document.body.style.overflow = "";
    }, 300);
  },

  isVisible() {
    return this.modal && this.modal.classList.contains("show");
  },

  toggle() {
    if (this.isVisible()) {
      this.hide();
    } else {
      this.show();
    }
  },
};

// Make SignupForm globally available
window.SignupForm = SignupForm;

// Product Carousel using Swiper
function initProductCarousel() {
  const carousels = document.querySelectorAll(".product-carousel");

  carousels.forEach((carouselElement) => {
    if (carouselElement._pcInitialized) return; // guard against double init

    const wrapper = carouselElement.querySelector(".product-carousel__track");
    const slides = Array.from(
      carouselElement.querySelectorAll(".product-carousel__slide")
    );
    const images = Array.from(
      carouselElement.querySelectorAll(".product-carousel__slide img")
    );

    let swiper = null;

    function enableSwiperMobile() {
      if (typeof Swiper === "undefined") {
        console.warn("Swiper library not loaded");
        return;
      }
      if (swiper) return; // already enabled

      // Clear any desktop inline overrides
      if (wrapper) {
        wrapper.style.justifyContent = "";
        wrapper.style.gap = "";
        wrapper.style.paddingInline = "";
      }
      slides.forEach((s) => {
        s.style.width = "";
        s.style.flex = "";
      });
      images.forEach((img) => {
        img.style.objectFit = ""; // revert to CSS (cover)
        img.style.height = "";
        img.style.width = "";
      });

      swiper = new Swiper(carouselElement, {
        slidesPerView: "auto", // honor slide widths but use breakpoints to approximate counts
        spaceBetween: 12,
        centeredSlides: false,

        touchRatio: 1,
        threshold: 5,
        touchAngle: 45,
        touchStartPreventDefault: false,
        touchMoveStopPropagation: true,
        resistance: true,
        resistanceRatio: 0.85,
        speed: 300,
        preventClicks: true,
        preventClicksPropagation: true,
        touchEventsTarget: "container",
        breakpoints: {
          // ~1.3 slides around 430px
          0: {
            slidesOffsetBefore: 12,
            slidesOffsetAfter: 12,
            spaceBetween: 12,
            slidesPerView: 1.3,
          },
          // ~2.3 slides as we approach 766px
          622: {
            slidesOffsetBefore: 12,
            slidesOffsetAfter: 12,
            spaceBetween: 12,
            slidesPerView: 2.3,
          },
        },
      });

      carouselElement.swiper = swiper;
    }

    function disableSwiperAndCenterDesktop() {
      if (swiper && typeof swiper.destroy === "function") {
        swiper.destroy(true, true);
        swiper = null;
        carouselElement.swiper = null;
      }

      // Center slides with 12px gap; ensure full image fits (no crop)
      if (wrapper) {
        wrapper.style.justifyContent = "center";
        wrapper.style.gap = "12px";
        // Add 12px padding before first slide and after last slide
        // wrapper.style.paddingInline = "12px";
      }

      // Compute per-slide width so that ALL slides fit horizontally and within viewport height
      const containerWidth = carouselElement.clientWidth;
      const gapPx = 12;
      const count = Math.max(1, slides.length);
      const viewportH = window.innerHeight || 800;
      const maxSlideH = Math.max(200, Math.min(724, viewportH - 160)); // leave some breathing room
      const aspect = 517 / 724; // w/h of the design asset
      const widthFromHeight = Math.floor(maxSlideH * aspect);
      const sidePadding = 12 * 2; // 12px before + 12px after
      const availableWidth = containerWidth - sidePadding - gapPx * (count - 1);
      const widthFromContainer = Math.floor(availableWidth / count);
      const finalWidth = Math.max(
        160,
        Math.min(517, widthFromHeight, widthFromContainer)
      );

      slides.forEach((s) => {
        s.style.flex = `0 0 ${finalWidth}px`;
        s.style.width = `${finalWidth}px`;
      });
      images.forEach((img) => {
        img.style.objectFit = "contain";
        img.style.height = "auto";
        img.style.width = "100%";
      });
    }

    function setupCarousel() {
      if (window.innerWidth <= 767) {
        enableSwiperMobile();
      } else {
        disableSwiperAndCenterDesktop();
      }
    }

    // Initial setup + responsive handling
    setupCarousel();
    const onResize = () => {
      clearTimeout(carouselElement._pcResizeTimer);
      carouselElement._pcResizeTimer = setTimeout(setupCarousel, 100);
    };
    window.addEventListener("resize", onResize);
    carouselElement._pcOnResize = onResize;
    carouselElement._pcInitialized = true;
  });
}

// Initialize carousels when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // Wait for Swiper to be available
  if (typeof Swiper !== "undefined") {
    initProductCarousel();
  } else {
    console.warn("Swiper library not loaded");
  }
});

// Make init function globally available
window.initProductCarousel = initProductCarousel;

// TEMPORARY: Test step 2 functionality
// document.addEventListener("DOMContentLoaded", function () {
//   // Wait a bit for everything to initialize, then show step 2
//   setTimeout(() => {
//     console.log("TEST: Opening modal on step 2");
//     if (window.SignupForm) {
//       window.SignupForm.show(2);
//     }
//   }, 1000); // 1 second delay
// });

// HEADER LOGO ANIMATION CONTROL

/**
 * =====================================================================
 * LOGO SCROLL ANIMATION SYSTEM (Vanilla JS)
 * =====================================================================
 * This animation dynamically separates, scales, and re-joins the logo
 * based on scroll position using vanilla JavaScript.
 *
 * Animation Flow:
 * 1. Logo starts joined in header
 * 2. When animation-start hits viewport center → logo splits and scales up
 * 3. Logo halves move to viewport edges and center vertically
 * 4. At midpoint → logo rejoins at center
 * 5. Logo returns to header position
 * 6. Smooth reverse behavior on scroll up
 * =====================================================================
 */

class LogoScrollAnimation {
  constructor() {
    // DOM Elements
    this.animationStart = document.querySelector("#animation-start");
    this.animationEnd = document.querySelector("#animation-end");
    this.logoLeft = document.querySelector(".header__logo-left");
    this.logoRight = document.querySelector(".header__logo-right");
    this.logoContainer = document.querySelector(".header__logo");

    // Detect reduced motion preference
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      console.log("Reduced motion enabled - skipping logo animation");
      return;
    }

    // Responsive Configuration
    this.isMobile = window.innerWidth < 768;
    this.updateConfig();

    // Animation state
    this.isInitialized = false;
    this.ticking = false;
    this.currentProgress = 0;

    // Scroll range cache
    this.scrollStart = 0;
    this.scrollEnd = 0;
    this.scrollRange = 0;

    if (window.lowPowerModeDetected) {
      return;
    }

    // Verify all required elements exist
    if (
      !this.animationStart ||
      !this.animationEnd ||
      !this.logoLeft ||
      !this.logoRight ||
      !this.logoContainer
    ) {
      console.warn("LogoScrollAnimation: Required elements not found");
      return;
    }

    this.init();
  }

  /**
   * Update configuration based on viewport size
   */
  updateConfig() {
    if (this.isMobile) {
      // Mobile configuration
      this.edgeOffset = 50;
      this.maxScale = 2.0; // Only 2x scale on mobile
      this.startViewportPosition = 0.2; // Start at 20% from top
      this.endViewportPosition = 0.4; // End at 80% from top
      this.centerTargetPosition = 0.35; // Target upper-third on mobile (35% from top)

      // Mobile-specific phase timings (faster separation, hold at edges)
      this.phase1End = 0.1; // Reach edges quickly
      this.phase2End = 0.85; // Hold at edges
      this.phase3End = 1.0; // Return to header
    } else {
      // Desktop configuration
      this.edgeOffset = 100;
      this.maxScale = 3.5; // 3.5x scale on desktop
      this.startViewportPosition = 0.5; // Start at 50% (center)
      this.endViewportPosition = 0.2; // End at 20% from top
      this.centerTargetPosition = 0.5; // Target true center on desktop

      // Desktop phase timings (balanced)
      this.phase1End = 0.33; // Separation
      this.phase2End = 0.7; // Center reunion
      this.phase3End = 1.0; // Header return
    }
  }

  /**
   * Initialize the animation system
   */
  init() {
    // Set initial CSS state
    this.setInitialState();

    // Calculate scroll positions
    this.calculateScrollPositions();

    // Bind scroll handler
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.handleScroll, { passive: true });

    // Handle window resize
    this.handleResize();

    this.isInitialized = true;
  }

  /**
   * Set initial CSS state for logo elements
   */
  setInitialState() {
    // Make logo images individually transformable
    [this.logoLeft, this.logoRight].forEach((logo) => {
      logo.style.position = "relative";
      logo.style.display = "inline-block";
      logo.style.transformOrigin = "center center";
      logo.style.willChange = "transform";
    });

    // Ensure container allows individual image movement
    this.logoContainer.style.display = "flex";
    this.logoContainer.style.alignItems = "center";
    this.logoContainer.style.justifyContent = "center";
  }

  /**
   * Calculate scroll trigger positions
   */
  calculateScrollPositions() {
    // Start: when animation-start center hits configured viewport position
    const startRect = this.animationStart.getBoundingClientRect();
    const startOffset =
      window.pageYOffset + startRect.top + startRect.height / 2;
    this.scrollStart =
      startOffset - window.innerHeight * this.startViewportPosition;

    // End: when animation-end center hits configured viewport position
    const endRect = this.animationEnd.getBoundingClientRect();
    const endOffset = window.pageYOffset + endRect.top + endRect.height / 2;
    this.scrollEnd = endOffset - window.innerHeight * this.endViewportPosition;

    // Calculate range
    this.scrollRange = this.scrollEnd - this.scrollStart;
  }

  /**
   * Calculate target positions for logo halves at full separation
   * Ensures symmetrical movement by using equal distances from container center
   */
  getTargetPositions() {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Get container center
    const logoRect = this.logoContainer.getBoundingClientRect();
    const containerCenterX = logoRect.left + logoRect.width / 2;

    // Calculate the maximum distance we can move (to viewport edge minus offset)
    const distanceToLeftEdge = containerCenterX - this.edgeOffset;
    const distanceToRightEdge =
      viewportWidth - containerCenterX - this.edgeOffset;

    // Use the smaller distance to ensure both logos fit within viewport
    const maxDistance = Math.min(distanceToLeftEdge, distanceToRightEdge);

    // Both logos move the SAME distance in opposite directions
    const leftTargetX = -maxDistance;
    const rightTargetX = maxDistance;

    // Calculate vertical distance to target position (configurable per viewport)
    const currentCenterY = logoRect.top + logoRect.height / 2;
    const targetY = viewportHeight * this.centerTargetPosition;
    const verticalOffset = targetY - currentCenterY;

    return {
      leftX: leftTargetX,
      rightX: rightTargetX,
      verticalY: verticalOffset,
    };
  }

  /**
   * Easing function for smooth animation
   * power2.inOut equivalent
   */
  easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  /**
   * Handle scroll events
   */
  handleScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.updateAnimation();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  /**
   * Update animation based on scroll position
   */
  updateAnimation() {
    const scrollY = window.pageYOffset;

    // Calculate progress (0 to 1)
    let progress = (scrollY - this.scrollStart) / this.scrollRange;
    progress = Math.max(0, Math.min(1, progress)); // Clamp between 0 and 1

    this.currentProgress = progress;

    // Get target positions
    const positions = this.getTargetPositions();

    // Animation has 3 phases with configurable timing:
    // Phase 1: Separation (0 to phase1End)
    // Phase 2: Hold at edges/center reunion (phase1End to phase2End)
    // Phase 3: Header return (phase2End to 1)

    let leftX, rightX, leftY, rightY, scale;

    if (progress <= this.phase1End) {
      // Phase 1: Separation (0 to phase1End)
      const phase1Progress = progress / this.phase1End;
      const eased = this.easeInOutQuad(phase1Progress);

      leftX = positions.leftX * eased;
      rightX = positions.rightX * eased;
      leftY = rightY = positions.verticalY * eased;
      scale = 1 + (this.maxScale - 1) * eased;
    } else if (progress <= this.phase2End) {
      // Phase 2: HOLD at edges (phase1End to phase2End)
      // Maintain full separation and scale
      leftX = positions.leftX;
      rightX = positions.rightX;
      leftY = rightY = positions.verticalY;
      scale = this.maxScale;
    } else {
      // Phase 3: Return to header (phase2End to 1)
      const phase3Progress =
        (progress - this.phase2End) / (this.phase3End - this.phase2End);
      const eased = this.easeInOutQuad(phase3Progress);

      // Return from edges to center, then to header
      leftX = positions.leftX * (1 - eased);
      rightX = positions.rightX * (1 - eased);
      leftY = rightY = positions.verticalY * (1 - eased);
      scale = this.maxScale - (this.maxScale - 1) * eased;
    }

    // Apply transforms
    this.logoLeft.style.transform = `translate(${leftX}px, ${leftY}px) scale(${scale})`;
    this.logoRight.style.transform = `translate(${rightX}px, ${rightY}px) scale(${scale})`;
  }

  /**
   * Handle window resize
   */
  handleResize() {
    let resizeTimeout;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);

      resizeTimeout = setTimeout(() => {
        // Check if viewport size changed (mobile/desktop switch)
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 768;

        // If viewport type changed, update configuration
        if (wasMobile !== this.isMobile) {
          this.updateConfig();
        }

        // Recalculate scroll positions
        this.calculateScrollPositions();

        // Update animation
        this.updateAnimation();
      }, 250);
    });
  }

  /**
   * Destroy the animation (cleanup method)
   */
  destroy() {
    // Remove scroll listener
    window.removeEventListener("scroll", this.handleScroll);

    // Reset transforms
    this.logoLeft.style.transform = "";
    this.logoRight.style.transform = "";
  }
}

// Initialize logo animation when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // Check if we're on a page with animation trigger elements
  const hasRequiredElements =
    document.querySelector("#animation-start") &&
    document.querySelector("#animation-end");

  if (hasRequiredElements) {
    // Initialize the logo animation
    window.logoScrollAnimation = new LogoScrollAnimation();
  }
});

/**
 * =====================================================================
 * PRODUCT DETAILS FADE ANIMATION (Vanilla JS)
 * =====================================================================
 * Fades out .product-details when .sticky-container bottom hits
 * the middle of the viewport, and fades back in when scrolling up.
 * =====================================================================
 */

class ProductDetailsFade {
  constructor() {
    // DOM Elements
    this.stickyContainer = document.querySelector(".sticky-container");
    this.productDetails = document.querySelector(".product-details");

    // Animation state
    this.isInitialized = false;
    this.ticking = false;
    this.triggerPoint = 0;

    // Verify required elements exist
    if (!this.stickyContainer || !this.productDetails) {
      console.warn("ProductDetailsFade: Required elements not found");
      return;
    }

    this.init();
  }

  /**
   * Initialize the fade animation
   */
  init() {
    // Calculate trigger point
    this.calculateTriggerPoint();

    // Bind scroll handler
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.handleScroll, { passive: true });

    // Handle resize
    this.handleResize();

    this.isInitialized = true;
  }

  /**
   * Calculate the scroll position where fade should occur
   * Triggers when sticky container bottom reaches bottom of viewport (100vh)
   */
  calculateTriggerPoint() {
    const stickyRect = this.stickyContainer.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // Calculate absolute position of sticky container bottom
    const stickyBottom =
      window.pageYOffset + stickyRect.top + stickyRect.height;

    // Trigger when sticky bottom hits bottom of viewport (100vh)
    // This means: stickyBottom - scrollY = viewportHeight
    // Therefore: scrollY = stickyBottom - viewportHeight
    this.triggerPoint = stickyBottom - viewportHeight;
  }

  /**
   * Handle scroll events
   */
  handleScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.updateFade();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  /**
   * Update fade based on scroll position
   * Fades out when sticky container stops being sticky
   */
  updateFade() {
    const scrollY = window.pageYOffset;

    // Calculate how far we are from the trigger point
    const distance = scrollY - this.triggerPoint;

    // Start fading as soon as we reach trigger point (0-200px range)
    const fadeRange = 200;
    let opacity = 1 - distance / fadeRange;
    opacity = Math.max(0, Math.min(1, opacity)); // Clamp between 0 and 1

    // Apply opacity
    this.productDetails.style.opacity = opacity;
  }

  /**
   * Handle window resize
   */
  handleResize() {
    let resizeTimeout;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);

      resizeTimeout = setTimeout(() => {
        // Recalculate trigger point
        this.calculateTriggerPoint();

        // Update fade
        this.updateFade();
      }, 250);
    });
  }

  /**
   * Destroy the animation (cleanup method)
   */
  destroy() {
    // Remove scroll listener
    window.removeEventListener("scroll", this.handleScroll);

    // Reset opacity
    this.productDetails.style.opacity = "";
  }
}

// Make ProductDetailsFade globally available
window.ProductDetailsFade = ProductDetailsFade;

// Initialize product details fade animation when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // Check if we're on a page with sticky container and product details
  const hasRequiredElements =
    document.querySelector(".sticky-container") &&
    document.querySelector(".product-details");

  if (hasRequiredElements) {
    // Initialize the fade animation
    window.productDetailsFade = new ProductDetailsFade();
  }
});
